import type { CmsDisplayTextLabel } from '@cms/interfaces/cmsDisplayTextLabel'
import { cmsToOccDisplayText } from '@cms/utils/cmsToOccDisplayText'
import type { DisplayTextProps } from '@vista-digital/occ-ui/src/lib/subcomponents/display-text/display-text'
import { DisplayText as DisplayTextComponent } from '@vista-digital/occ-ui/src/lib/subcomponents/display-text/display-text'
import type { FunctionComponent } from 'react'
import { useNavigate } from 'react-router-dom-v7'

export const DisplayText: FunctionComponent<{ label: CmsDisplayTextLabel[] }> = props => {
    const navigate = useNavigate()

    if (!props.label || props.label.length < 1) return null

    const occProps: DisplayTextProps = {
        label: cmsToOccDisplayText(props.label, navigate),
    }
    return <DisplayTextComponent {...occProps} />
}
